import produce from 'immer';
import { AnyAction } from 'redux';
import {
  FETCH_BLOCKCHAIN_NFTS_ERROR,
  FETCH_BLOCKCHAIN_NFTS_LOADING,
  FETCH_BLOCKCHAIN_NFTS_SUCCESS,
  FETCH_MORE_BLOCKCHAIN_NFTS_ERROR,
  FETCH_MORE_BLOCKCHAIN_NFTS_LOADING,
  FETCH_MORE_BLOCKCHAIN_NFTS_SUCCESS
} from 'appRedux/ActionTypes';
import { BlockchainNft, Meta } from 'interfaces';

type InitialState = {
  loading: boolean;
  loaded: boolean;
  error: string;
  data: BlockchainNft[];
  meta: Meta;
};

export const INIT_STATE: InitialState = {
  loading: false,
  loaded: false,
  error: '',
  data: [],
  meta: {
    pageKey: '',
    totalCount: 0
  }
};

export const BlockchainNftReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialState =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_BLOCKCHAIN_NFTS_LOADING:
        draft.loading = true;
        draft.loaded = false;
        draft.error = '';
        break;

      case FETCH_BLOCKCHAIN_NFTS_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        draft.data = action.payload.data;
        draft.meta = action.payload.meta;
        break;

      case FETCH_BLOCKCHAIN_NFTS_ERROR:
        draft.loading = false;
        draft.loaded = true;
        draft.error = action.payload;
        break;

      case FETCH_MORE_BLOCKCHAIN_NFTS_LOADING:
        draft.loading = true;
        draft.loaded = false;
        draft.error = '';
        break;

      case FETCH_MORE_BLOCKCHAIN_NFTS_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        draft.data.push(...action.payload.data);
        draft.meta = action.payload.meta;
        break;
      case FETCH_MORE_BLOCKCHAIN_NFTS_ERROR:
        draft.loading = false;
        draft.loaded = true;
        draft.error = action.payload;
        break;
    }
  });
